import { Component, OnInit, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'util';
import { Store } from '@ngrx/store';


import * as AES from 'crypto-js/aes';
import * as Utf8 from 'crypto-js/enc-utf8';
import { UserPlanService } from '../../service/userplan.service';
import { HttpClient } from '@angular/common/http';
import { AppState } from 'src/app/models/app.state';
import { Subject } from 'rxjs';
import { JOIN_BUILDING } from 'src/app/reducers/building.reducers';
import * as CryptoJS from 'crypto-js';

//Base64 encode of 'mycoopSocialNetwork'
var secretKey = 'bXljb29wU29jaWFsTmV0d29yaw==';
var initialLoad = false;
var userNameOut = '';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit, AfterViewInit, OnDestroy {

  //Call a constructor function initialy load
  constructor(private _http: HttpService,
    private http: HttpClient,
    private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private plan: UserPlanService,
  ) { }

  //Declare variables
  user: any = '';
  userName = '';
  error;
  loginStatus = new Subject();
  buildingIds = [];
  errorState: boolean = false;
  activateUserId = '';
  private sub: any = null;

  /*
  * When user click activation link this ngOnInit function invoke very first
  * Then verfify the user account and make a auto login process
  * to this verified user
  */
  ngOnInit() {
    if (initialLoad === false) {
      const encryptedText = this.route.snapshot.queryParams['encrypt'];
      const info = this.route.snapshot.queryParams['info'];
  
      let decryptInfo = null;
  
      if (encryptedText || info) {
        // Prefer `info` if present
        let textToDecrypt = info || encryptedText;
  
        // 1. Decode URL
        let decoded = decodeURIComponent(textToDecrypt);
  
        // 2. Replace spaces with '+', if backend didn't encode properly
        decoded = decoded.replace(/ /g, '+');
  
        // 3. Decrypt
        let bytes = CryptoJS.AES.decrypt(decoded, secretKey);
  
        // 4. Convert to UTF-8
        decryptInfo = bytes.toString(CryptoJS.enc.Utf8);
  
        console.log('✅ Decrypted info:', decryptInfo);
  
        // Split into individual values
        const userInfo = decryptInfo.split("&");
        const userId = userInfo[0].split('=')[1];
        const name = userInfo[1].split('=')[1];
        const updatedAt = userInfo[2].split('=')[1];
        const token = userInfo[3].split('=')[1];
        console.log('✅ userInfo :', userInfo);

        const updatedDate = new Date(updatedAt).getTime();
        const currentDate = new Date().getTime();
        const diff = currentDate - updatedDate;
  
        if (userId) this.activateUserId = userId;
        this.userName = name;
        userNameOut = name;
  
        if (this.sub) this.sub.unsubscribe();
  
        // Handle `info` (set password) flow
        if (info && userId) {
          this._http.getUser(userId).subscribe((res) => {
            if (res.user && !res.user.isActive && !res.user.deleted) {
              const buildingData = res.user.building[0];
              const userData = {
                firstName: res.user.firstName,
                lastName: res.user.lastName,
                email: res.user.email,
              };
              this.plan.setUserData({ userData: res.user });
              this.store.dispatch({
                type: JOIN_BUILDING,
                payload: { address: buildingData, userData: userData }
              });
  
              this.router.navigate(['/building/profile'], { queryParams: { account: 'setup' } });
            } else if (res.user && res.user.deleted) {
              this.error = 'Your account had been disabled by an Administrator. Please contact <a href="mailto:hello@mycoop.com" target="_blank"> hello@mycoop.com</a> for more information.';
              this.errorState = true;
              this.loginStatus.next(false);
              this.showThankYouModal();
            } else if (res.user && res.user.isActive) {
              this.error = 'Already your account has been activated.<br> <a (click)="resendForgotPasswordLink()" class="forgotPasswordLink"> Click here</a> to send a forgot password email.';
              this.errorState = true;
              this.loginStatus.next(false);
              this.showThankYouModal();
            }
          });
        }
  
        // Handle `encryptedId` (verify user) flow
        if (encryptedText && userId) {
          this.sub = this._http.userVerify(userId, token).subscribe((res) => {
            debugger
            if (res.userTokenExpired) {
              this.error = 'Your activation link has expired.<br> <a (click)="resendActivationLink()" class="activateLink"> Click here</a> to receive a new activation email.';
              this.errorState = true;
              this.loginStatus.next(false);
              this.showThankYouModal();
            } else if (res.activeUser) {
              this.error = 'Your account has already been activated. <a (click)="resendForgotPasswordLink()" class="forgotPasswordLink"> Click here</a> to retrieve password.';
              this.errorState = true;
              this.loginStatus.next(false);
              this.showThankYouModal();
            } else if (res.user) {
              this.errorState = false;
              this.error = null;
  
              if (res.success === false) {
                this.errorState = true;
                this.error = res.message[0];
                this.loginStatus.next(false);
              } else if (res.token) {
                setTimeout(() => this.loginStatus.next(true), 2000);
  
                const buildingIds = res.user.building.map(b => b.id);
                const isManager = res.user.type === 'manager';
                localStorage.setItem('token', res.token);
                localStorage.setItem('userBuildingId', isManager ? buildingIds.toString() : res.user.building[0].id);
                localStorage.setItem('residents', res.user.id);
                localStorage.setItem('type', res.user.type);
                localStorage.setItem('maintenance', res.user.isMaintenanceManager);
                localStorage.setItem('isManager', isManager.toString());
              }
            }
  
            initialLoad = true;
          }, (error) => {
            const data = JSON.parse(error._body);
            this.error = data.message;
            this.errorState = true;
            this.loginStatus.next(false);
            this.showThankYouModal();
          });
        }
  
      } else {
        // Already loaded
        this.userName = userNameOut || '';
      }
    }
  }
  

  ngAfterViewInit() {

    //Show modal popup when complete the auto login process after user account has been verified successfully
    this.loginStatus.subscribe((status) => {
      console.log(status)
      if (status) {
        this.showThankYouModal();
      }
    });
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('activateLink')) {
      this._http.resendActivationLinkById(this.activateUserId).subscribe((res) => {
        if (res) {
          this.error = res.message[0];
          setTimeout(() => {
            this.closeThankYouModal();
            this.router.navigate(['/']);
          }, 5000);
        }
      });
    } else if (target.classList.contains('forgotPasswordLink')) {
      this.closeThankYouModal();
      this.router.navigate(['/building', 'forgotPassword']);
    }
  }

  fireEvent() {
  }

  /*
  * Modal popup close when click 'close' icon on modal popup
  */
  modalClose() {
    this.closeThankYouModal();
    window.location.href = '/feed';
  }

  ngOnDestroy() {
    this.closeThankYouModal();
  }

  showThankYouModal() {
    const modal = document.getElementById('thankyou_modal');
    if (modal) modal.style.display = 'block';
  }

  closeThankYouModal() {
    const modal = document.getElementById('thankyou_modal');
    if (modal) modal.style.display = 'none';
  }
}
